<template>
  <div class="progress-view">
    <el-row class="row-bg">
      <el-col :span="12">
        <div class="progress-title">购买日期</div>
      </el-col>
      <el-col :span="12">
        <div class="progress-subtitle">{{progress.purchaseDate}}</div>
      </el-col>
    </el-row>
    <br />
    <el-row>
      <el-col :span="24">
        <el-progress
          :text-inside="true"
          :stroke-width="18"
          :percentage="progress.progress"
          :color="progressColor"
          status="warning"
          class="progress-bar-view"
        ></el-progress>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg" justify="space-between">
      <el-col :span="12">
        <p class="current-title">已拥有 {{progress.current}} 天</p>
      </el-col>
      <el-col :span="12">
        <p class="target-title">{{progress.target}}天</p>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    progress: Object
  },
  data() {
    return {
      progressColor: '#FFB547'
    }
  }
};
</script>

<style>
.current-title {
  font-family: PingFangSC-Medium;
font-size: 13px;
color: #333333;
letter-spacing: 0;
/* text-align: center; */
line-height: 16px;
}
.target-title {
  text-align: right;
  font-family: PingFangSC-Medium;
font-size: 13px;
color: #333333;
letter-spacing: 0;
/* text-align: center; */
line-height: 16px;
}
.row-bg {
  margin-left: 16px;
  margin-right: 16px;
}
.progress-subtitle {
  font-family: PingFangSC-Medium;
  font-size: 13px;
  color: #53c384;
  letter-spacing: 0;
  line-height: 16px;
  margin-top: 16px;
  text-align: right;
}
.progress-title {
  font-family: PingFangSC-Medium;
  font-size: 13px;
  color: #53c384;
  letter-spacing: 0;
  line-height: 16px;
  margin-top: 16px;
}
.progress-view {
  background: #ffffff;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.03);
  border-radius: 12px;
  width: 359px;
  height: auto;
  margin-left: 8px;
}
.progress-bar-view {
  margin-left: 16px;
  margin-right: 16px;
}
</style>